// extracted by mini-css-extract-plugin
export default {"dateCell":"DateCell_dateCell__YdwrE","dateInfo":"DateCell_dateInfo__o1t07"};